import {
  DEFAULT_FILTER_PRIORITY,
  type FilterBlock,
  type FilterQuery,
  type IndexedBlockValueItem,
  ValidationTypes,
} from '@github-ui/filter-core'
import {KeyOnlyFilterProvider} from '@github-ui/filter-core/providers'
import {GitCommitIcon} from '@primer/octicons-react'
import {singleValueFilterTypes} from '@github-ui/repos-rules-types/shared-filter-types'

// Matches 7-64 hex characters (valid short or full SHA-1/SHA-256)
const VALID_OID_REGEX = /^[a-fA-F0-9]{7,64}$/

export class ShaFilterProvider extends KeyOnlyFilterProvider {
  constructor() {
    super(
      {
        displayName: 'Commit SHA',
        key: 'sha',
        priority: DEFAULT_FILTER_PRIORITY,
        icon: GitCommitIcon,
        description: 'Filter by commit SHA',
      },
      {
        filterTypes: singleValueFilterTypes,
        priority: DEFAULT_FILTER_PRIORITY,
      },
    )
  }

  override validateFilterBlockValues(
    _filterQuery: FilterQuery,
    _block: FilterBlock,
    values: IndexedBlockValueItem[],
  ): IndexedBlockValueItem[] {
    return values.map(value => {
      const rawValue = typeof value.value === 'function' ? value.value() : value.value
      const sha = rawValue?.trim().toLowerCase()

      if (!sha || !VALID_OID_REGEX.test(sha)) {
        return {
          ...value,
          valid: false,
          validations: [
            {
              type: ValidationTypes.InvalidValue,
              message: 'SHA must be 7-64 hexadecimal characters',
            },
          ],
        }
      }

      return {
        ...value,
        value: sha,
        displayName: sha,
        valid: true,
      }
    })
  }
}
